module.exports = __webpack_public_path__ + "amex-icon.png?0ce61b8ea0f1b318bda197069b76ba87";


//////////////////
// WEBPACK FOOTER
// ./src/assets/amex-icon.png
// module id = 1043
// module chunks = 0